import React from "react";
var __jsx = React.createElement;
// eslint-disable-next-line import/no-extraneous-dependencies
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageLoader } from 'components/common/material-ui/custom-components';
import { useContentWithRedirect } from 'libs/content/hooks';
import { getContentType } from 'libs/content/utils';
import { flushDependencies, getPreview } from 'redux/content';
import ContentFormWrapper from '../../../ContentForm/ContentFormWrapper';

var Edit = function Edit() {
  var _useRouter = useRouter(),
      id = _useRouter.query.id;

  var dispatch = useDispatch();

  var _useSelector = useSelector(getPreview),
      previewLoading = _useSelector.loading;

  var _useContentWithRedire = useContentWithRedirect(id),
      firstLoadContent = _useContentWithRedire.firstLoadContent,
      contentLoading = _useContentWithRedire.loading; // flush content dependencies


  useEffect(function () {
    dispatch(flushDependencies());
  }, [dispatch]);
  var contentType = useMemo(function () {
    return firstLoadContent ? getContentType(firstLoadContent.contentType) : undefined;
  }, [firstLoadContent]);

  if (contentType === undefined || firstLoadContent === undefined) {
    return __jsx(PageLoader, {
      open: true
    });
  }

  return __jsx(ContentFormWrapper, {
    contentType: contentType,
    firstLoadContent: firstLoadContent,
    loading: contentLoading || previewLoading
  });
};

export default Edit;